import { Outlet } from 'react-router-dom';

import { TabItem, Tabs } from 'components/tabs';

interface AccountSettingsPageProps {
  tabs: TabItem[];
  selected?: TabItem;
}

export const Settings = ({ tabs, selected }: AccountSettingsPageProps) => {
  return (
    <>
      <Tabs items={tabs} selected={selected} />
      <Outlet />
    </>
  );
};
